import { render, staticRenderFns } from "./cgzp.vue?vue&type=template&id=64919420&"
import script from "./cgzp.vue?vue&type=script&lang=js&"
export * from "./cgzp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports